import React, { useEffect, useState, useRef } from "react";
import ReactHtmlParser from "react-html-parser";
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import Str from "../../common/Str";
import AssignmentStatus from "../../course/AssignmentStatus";
import AssignmentType from "../../course/AssignmentType";
import { zeroPad } from "react-countdown";
import { SystemIcons } from "../../common/SystemIcons";
import { SysCheckSideIcon } from "../../common/SysCheckSideIcon";
import { RenderAttachList } from "../../common/RenderAttachList";
import Swal from "sweetalert2";
import { AssessmentAuditTracks, AssignmentSubmission, GetAssignmentDetail } from "../../../services/QualificationService";
import ViewQuestion from "../quiz/ViewQuestionExam";
import { useDispatch, useSelector } from "react-redux";
import { setIsExamLaunched,setCurrAssessment, setQuizComplete, clearQuiz, clearPosition } from "../../../store/actions";
import $ from 'jquery';
import moment from "moment";
import { useParams } from "react-router-dom";
import { calculateTimeLeftOpt,CustomFileUploadPreview, formatToTimeZone } from "../../../utils/CommonGroupingItem";
import { getRandomInt } from "../../../utils/commonFunction";
import { GetQuizQuestionsService } from "../../../services/QuizService";

const Step5 = (props) => {
  const [showFile, setShowFile] = useState(true);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(null);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [open, setOpen] = useState(true);
  const {quizTotalTime} = props;
  const { examLaunched,isAssessmentReview } = useSelector(state=>state.examLaunched);
  const dispatch = useDispatch();
  const [hasBeenSetToFinal, setHasBeenSetToFinal] = useState(false);
  const [submitQuizAssessment, setSubmitQuizAssessment] = useState(false);
  const [fileInProgress, setFileInProgress] = useState(0);
  const [assessmentStatus, setAssessmentStatus] = useState(props.data.status ? props.data.status : "");
  const [isTimeUp, setIsTimeUp] = useState(false);
  const [timeLeft, setTimeLeft] = useState("00:00:00");
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [dropzoneFileInfo, setDropzoneFileInfo] = useState([]);
  const [autoSubmitDetails,setAutoSubmitDetails] = useState({now : 0,closeTime : 0,timeLeftFromCloseTime : 0});
  const dropzoneFileInfoRef = useRef(dropzoneFileInfo);
  const [isSigRequired,setIsSigRequired] = useState(false);
  const [sigPoped,setSigPoped] = useState(false);
  const [canBeSTF,setCanBeSTF] = useState(false);
  const { sid } = useParams();
  const [isSubmitManual, setIsSubmitManual] = useState(false);
  const {position} = useSelector(state => state.assessmentEvidence);
  const [swalShown,setSwalShown] = useState(false);

  const debounceRef = useRef(null);
  const [uploadProgress , setUploadProgress] = useState([]);
  const [isMinutePopupShown,setIsMinutePopupShown] = useState(false)
  const [toShowMinutePopup,setToShowMinutePopup] = useState(true)

  useEffect(() => {
    if(!props.isRecord && !props.screenShareCheck && props.data.screen_share){
       dispatch(setIsExamLaunched({...examLaunched, isExamLaunched: false, isClicked: false }));
        props.parentCall(); 
    }
  },[props.isRecord,props.screenShareCheck])
  const [currentTimezone, setCurrentTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

  useEffect(() => {
    dispatch(clearPosition())
  },[])


  useEffect(() => {
    if(props?.submitQuizAssessment){
      setSubmitQuizAssessment(props.submitQuizAssessment);
    }
  }, [props?.submitQuizAssessment]);

  const updateSubmitQuizAssessment = () => {
    props.updateSubmitQuizAssessment();
    setSubmitQuizAssessment(false);
  }

  useEffect(()=>{
    if(isTimeUp && props?.data.launched === 1 && !hasBeenSetToFinal && (props.data.timeLimitActive === 1 ? true : (autoSubmitDetails?.now || autoSubmitDetails?.closeTime)) && !position?.length){
      if(props.data.quiz_id == 0){
        if(fileInProgress<=0 && props.fileSubmitted==true){
          props.setToFinal(true,autoSubmitDetails);
          setHasBeenSetToFinal(true);
        }
      } else {
        setSubmitQuizAssessment(true);
        setHasBeenSetToFinal(true);
      }
    }else if(position?.length && isTimeUp && !swalShown){
      setSwalShown(true);
      Swal.fire({
        title: 'Time Over!',
        text : 'Your evidence is being uploaded',
        showConfirmButton : false,
        allowOutsideClick : false,
        allowEscapeKey : false,
        onOpen: function () {
          Swal.showLoading();
        },
      })
    }
  },[props, hasBeenSetToFinal,isTimeUp, autoSubmitDetails,swalShown,position ]);

  useEffect(() => {
    if (props?.data?.timeLimitActive && props?.data?.launched === 1 && props?.data.remainingDuration > 0 ) {
      let myInterval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        }
        if (seconds === 0 && !isSubmitManual && !position.length) {
          if (minutes === 0) {
            if (hours === 0) {
              if(props.data.quiz_id > 0 && !hasBeenSetToFinal){
                setHasBeenSetToFinal(true)
              } else if(!hasBeenSetToFinal) {
                if(fileInProgress<=0 ){
                  if(props.fileSubmitted==true){
                    props.setToFinal(true);
                    setHasBeenSetToFinal(true)                                      
                  }else{
                    $(".submit-file-button").click();                  
                  }
                }else{
                  props.setFileSubmitted(false);
                  setDisableFileUpload(true);
                }                
              }
              clearInterval(myInterval)
            }
            else {
              setHours(hours - 1);
              setMinutes(59)
              setSeconds(59);
            }

          } else {
            setMinutes(minutes - 1);
            setSeconds(59);
          }
        }
      }, 1000)
      return () => {
        clearInterval(myInterval);
      };
    }
  });

  useEffect(() => {
    if (props.assessmentId) {
      let aid = props.assessmentId;
      let tId = setTimeout(() => {
        GetAssignmentDetail({ aid, intake_id: sid })
          .then((res) => {
            // handling the timezone
            res.data.open_date_time = formatToTimeZone(res?.data?.open_date_time)
            res.data.close_date_time = formatToTimeZone(res?.data?.close_date_time)
            res.data.marking_deadline_date = formatToTimeZone(res?.data?.marking_deadline_date)
            if (res?.data && res?.data?.remainingDuration > 0) {
                const remainingTime = calculateTimeLeft(res?.data, true);
                setTimeLeft(remainingTime)
                const {hours, minutes, seconds} = calculateTimeLeft(res?.data);
                setHours(hours)
                setMinutes(minutes)
                setSeconds(seconds)
              } else {
                const remainingTime = calculateTimeLeft(res?.data, true);
                setTimeLeft(remainingTime)
                const {hours, minutes, seconds} = calculateTimeLeft(res?.data);
                setHours(hours)
                setMinutes(minutes)
                setSeconds(seconds)
            }
          })
          .catch((error) => { });
      }, 1000);

      return ()=>{clearTimeout(tId)}
    }
  }, []);

  useEffect(() => {
    let { hours, minutes, seconds } = calculateTimeLeft(props.data);
    if (((hours * 60 * 60) + (minutes * 60) + seconds) > 0 && ((hours * 60 * 60) + (minutes * 60) + seconds) <= 180 && props?.data.launched && props?.data.timeLimitActive) {
      if(toShowMinutePopup){
        if (((hours * 60 * 60) + (minutes * 60) + seconds) === 180 || ((hours * 60 * 60) + (minutes * 60) + seconds) === 60) {
          setIsMinutePopupShown(true)
          Swal.fire(`<p style='color:red'> Only ${zeroPad(((hours * 60) + minutes))} minutes left </p>`);
        }
      }
    }
  }, [timeLeft,toShowMinutePopup]);

  const uploadQueuedFiles = (dropzoneFileInfo) => {
    if(dropzoneFileInfo.length && dropzoneFileInfo.every(item => item.status !== 'preparing')){
      autoHandleSubmit(dropzoneFileInfo,dropzoneFileInfo,props.data);
      setDropzoneFileInfo([])
    }
  }

  const autoHandleSubmit = (files, allFiles, row) => {
      Swal.close();
      Swal.fire({
        icon: "info",
        title: 'Processing File...',
        text: 'Upload may take a bit longer than usual',
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      if(files.length){
        const formInputs = new FormData();
        files.map((f, index) => {
          formInputs.append('file_' + index, f.file)
        })
        formInputs.append('assignmentRow1', JSON.stringify(row));
        AssignmentSubmission(formInputs)
          .then((res) => {
            setDropzoneFileInfo([])
            props.setToFinal(true)
            props.setDocumentUploaded(true)
            Swal.close();
            Swal.fire({
              icon: "success",
              title: 'Submission Received',
              text: 'To Finalize your submission please set the status to Final.',
              showConfirmButton: true
            }).then((result) => {
            });
          })
          .catch((error) => {
            if(error.response && error.response.status && error.response.status ==400 && error.response?.data?.alreadySubmitted==true){
              Swal.fire({
                icon: "info",
                title: "Assessment already submitted",
                text: error.response.data.message,
              }).then(()=>{
              })
            }else{
              Swal.fire({
                icon: "error",
                title: "Submission Could not be Completed.",
              }).then((result) => {});
            }
          });
      }else{
        Swal.close();
      }
    }

    const openPopup = () => {
      let localData = localStorage.getItem('Signatureqa');
      let string = "";
      if(localData){
        let data = JSON.parse(localData);
        if((!data?.signature || data?.signature == null || data?.signature == undefined || data?.signature == '' || data?.signature == "null" || data?.signature == "undefined") && !data?.is_terms_checked){
          string = "Please provide signature and check the terms and conditions to proceed."
        }
        else if(!data?.signature || data?.signature == null || data?.signature == undefined || data?.signature == '' || data?.signature == "null" || data?.signature == "undefined"){
          string = "Please provide signature to proceed."
        }else if(!data?.is_terms_checked){
          string = "Please check the terms and conditions to proceed."
        }
      }else{
        string = "Please provide signature and check the terms and conditions to proceed."
      }
      if(string == "") {
        return true
      }
      else {
        let sigPopedCalled = false;
        const fallbackTimer = setTimeout(() => {
          if (!sigPopedCalled) {
            setSigPoped(true);
            sigPopedCalled = true;
          }
        }, 1000);

        Swal.fire({
          title: 'Time over!',
          text: string,
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          allowOutsideClick:false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (!sigPopedCalled && result.isConfirmed) {
            clearTimeout(fallbackTimer);
            setSigPoped(true);
            sigPopedCalled = true;
          }
        });
      }
    }

  const intervalRef = useRef(null);

  useEffect(() => {
    if(canBeSTF){
      setIsTimeUp(true);
      uploadQueuedFiles(dropzoneFileInfoRef.current);
      setSeconds(0);
    }
  },[canBeSTF])

  // Fix for the useEffect that monitors time for non-time-limited assessments
  useEffect(() => {
    if (props.assessmentId) {
      let aid = props.assessmentId;
      let intake_id = sid;

      // Clear the previous interval before setting a new one
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    
      if (props.data.timeLimitActive === 1) {
        if (isTimerActive || props.data.launched === 1) {
          
          GetAssignmentDetail({ aid, intake_id })
            .then((res) => {
              if (!res.data) {
                console.error("Failed to load assessment data");
                return;
              }
              // handling the timezone
              res.data.open_date_time = formatToTimeZone(res?.data?.open_date_time)
              res.data.close_date_time = formatToTimeZone(res?.data?.close_date_time)
              res.data.marking_deadline_date = formatToTimeZone(res?.data?.marking_deadline_date)

              setAssessmentStatus(res.data.status);
              intervalRef.current = setInterval(() => {
                const newTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                if (newTimezone !== currentTimezone) { 
                  setCurrentTimezone(newTimezone);
                  props.setAssignmentReload(getRandomInt(5000));
                } else {
                  let timeRemaining = calculateTimeLeft(res.data, true);
                  setTimeLeft(timeRemaining);
                  if (timeRemaining !== "--:--:--" && timeRemaining === "00:00:00" && res.data &&
                    (res.data.startTime && res.data.timeHour !== undefined && res.data.timeMin !== undefined)) {
                    setHours(0);
                    setMinutes(0);
                    setDisableFileUpload(true);
                    setAssessmentStatus("Closed Not-Submitted");
                    if(res.data?.is_student_signature_required) {
                      const popupConfirmed = openPopup();
                      setIsSubmitManual(true)
                      if(popupConfirmed) {
                        setIsTimeUp(true);
                        uploadQueuedFiles(dropzoneFileInfoRef.current);
                        setSeconds(0);
                      }
                      // Only run these functions immediately if signature is not required or is already valid
                    } else {
                      // If signature is not required, run these functions immediately
                      setIsTimeUp(true);
                      uploadQueuedFiles(dropzoneFileInfoRef.current);
                      setSeconds(0);
                      try{
                        let localData = localStorage.getItem('Monitoring Object' + aid)
                        if(localData){
                            localStorage.removeItem('Monitoring Object' + aid)
                        }
                      }catch(err){
                        console.log(err)
                      }
                    }
                    clearInterval(intervalRef.current);
                  }
                }
              }, 1000);
            })
            .catch((error) => {});
        }
      } else {
        GetAssignmentDetail({ aid, intake_id })
          .then((res) => {
            if (!res.data) {
              console.error("Failed to load assessment data");
              return;
            }
            // handling the timezone
            res.data.open_date_time=formatToTimeZone(res.data.open_date_time)
            res.data.close_date_time=formatToTimeZone(res.data.close_date_time)
            res.data.marking_deadline_date = formatToTimeZone(res.data.marking_deadline_date)
            setAssessmentStatus(res.data.status);
            intervalRef.current = setInterval(() => {
              // Calculate remaining time from close date
              const now = new Date().getTime();
              const closeTime = new Date(res.data?.close_date_time).getTime();
              const timeLeftFromCloseTime = closeTime - now;
              function formatDuration(milliseconds) {
                // Check if the duration is negative
                const isNegative = milliseconds < 0;
                const absoluteMs = Math.abs(milliseconds);
                
                // Calculate total seconds
                const totalSeconds = Math.floor(absoluteMs / 1000);
                
                // Extract hours, minutes, seconds
                const hours = Math.floor(totalSeconds / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = totalSeconds % 60;
                
                // Format with leading zeros
                const formattedHours = String(hours).padStart(2, '0');
                const formattedMinutes = String(minutes).padStart(2, '0');
                const formattedSeconds = String(seconds).padStart(2, '0');
                
                // Add negative sign if needed
                const sign = isNegative ? '-' : '';
                return `${sign}${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
              }
              
              
              
              // Only trigger time up if the time is actually up
              if (timeLeftFromCloseTime <= 0) {
                setHours(0);
                setMinutes(0);
                setDisableFileUpload(true);
                setAssessmentStatus("Closed Not-Submitted");
                setAutoSubmitDetails({
                  now: moment(now).format("DD MMM YYYY HH:mm"),
                  closeTime: res.data?.close_date_time,
                  timeLeftFromCloseTime: formatDuration(timeLeftFromCloseTime)
                });
                if(res.data?.is_student_signature_required) {
                  const popupConfirmed = openPopup();
                  if(popupConfirmed) {
                    setIsTimeUp(true);
                    uploadQueuedFiles(dropzoneFileInfoRef.current);
                    setSeconds(0);
                  }
                  // Only run these functions immediately if signature is not required or is already valid
                } else {
                  // If signature is not required, run these functions immediately
                  setIsTimeUp(true);
                  uploadQueuedFiles(dropzoneFileInfoRef.current);
                  setSeconds(0);
                  try{
                    let localData = localStorage.getItem('Monitoring Object' + aid)
                    if(localData){
                        localStorage.removeItem('Monitoring Object' + aid)
                    }
                  }catch(err){
                    console.log(err)
                  }
                }
                clearInterval(intervalRef.current);
              }
            }, 1000); // Changed from 5000 to 1000 for more consistent timing
          })
          .catch((error) => {});
      }
    }
  
    // Cleanup function to clear the interval when dependency changes
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isTimerActive, props?.reloadchild]); 
  
  // Fix for the auto-upload when files are queued
  useEffect(() => {
    // Only trigger auto-upload if time is actually up and uploads are disabled
    if(disableFileUpload && isTimeUp){
      uploadQueuedFiles(dropzoneFileInfo);
    }
  }, [dropzoneFileInfo, disableFileUpload, isTimeUp]);

  // Update the ref whenever dropzoneFileInfo changes
  useEffect(() => {
    dropzoneFileInfoRef.current = dropzoneFileInfo;
  }, [dropzoneFileInfo]);

  useEffect(() => {
    if(disableFileUpload){
      document.querySelectorAll('.dzu-previewButton').forEach(button => button.style.display = 'none')
    }
  },[disableFileUpload,dropzoneFileInfo])

  function callAPI() {
    // Only proceed if launched is true and the function hasn't been called yet
    if (props?.data?.launched && !localStorage.getItem('apiCalled')) {  
      const data = {
        assId: props.assessmentId,
        isClosed: 1,
      };
      
      // Use a more reliable method for beforeunload context
      // Option 1: Using fetch with keepalive
      AssessmentAuditTracks(data)
      .then((response) => {console.log(response.data)})
      .catch((error) => {console.log(error)})
      dispatch(setCurrAssessment({id : props.assessmentId, isClosed : 1}))
      localStorage.setItem('apiCalled', 'true');
    }
  }

    // Listen for beforeunload event
    window.addEventListener('beforeunload', function(event) {
      callAPI();
    });
  
  const currentTimeStatus = (h, m, s) => {
    setHours(h)
    setMinutes(m)
    setSeconds(s)
  }

  const TimeLeft = (data) => {
    
    // If we have time data available, use it immediately
    if (data?.timeHour !== undefined && data?.timeMin !== undefined) {
      const h = parseInt(data.timeHour) || 0;
      const m = parseInt(data.timeMin) || 0;
      const s = 0;
      
      // Set the initial time values
      setHours(h);
      setMinutes(m);
      setSeconds(s);
      
      // Also update the formatted timeLeft string
      setTimeLeft(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`);
    }
    
    // Then request the updated data from the server
    if (props.assessmentId) {
      setIsTimerActive(true);
      let aid = props.assessmentId;
      GetAssignmentDetail({ aid, intake_id: sid })
        .then((res) => {
          // handling the timezone
          res.data.open_date_time=formatToTimeZone(res?.data?.open_date_time)
          res.data.close_date_time=formatToTimeZone(res?.data?.close_date_time)
          res.data.marking_deadline_date = formatToTimeZone(res?.data?.marking_deadline_date)
          if (res?.data && res?.data?.remainingDuration > 0) {
            const remainingTime = calculateTimeLeft(res?.data, true);
            setTimeLeft(remainingTime);
            
            const {hours, minutes, seconds} = calculateTimeLeft(res.data);
            setHours(hours);
            setMinutes(minutes);
            setSeconds(seconds);
          }
        })
        .catch((error) => {
          console.error("Error fetching time data:", error);
        });
    }
  }
  // Function to properly calculate the time left for the assessment
  let initialServerTimestamp = 0;
  let initialPerformanceTime = 0;
  let timeInitialized = false;

  const calculateTimeLeft = (data, string = false) => {
    // Check if data is loaded before doing calculations
    if (!data || !data.nowtimestamp) {
      return string ? "--:--:--" : { hours: null, minutes: null, seconds: null };
    }

    // Initialize time tracking on first call
    if (!timeInitialized) {
      initialServerTimestamp = data.nowtimestamp;
      initialPerformanceTime = performance.now();
      timeInitialized = true;
    }

    // Calculate current time based solely on server time plus elapsed performance time
    const elapsedSeconds = Math.floor((performance.now() - initialPerformanceTime) / 1000);
    const now = initialServerTimestamp + elapsedSeconds;

    let timeLeft = null;

    // Calculate time left based on close time (if available)
    if (data.close_date_time) {
      let closeTimeUnix;
      if (typeof data.close_date_time === 'number') {
        closeTimeUnix = data.close_date_time;
      }
      else if (!isNaN(Number(data.close_date_time))) {
        closeTimeUnix = Number(data.close_date_time);
      }
      else {
        closeTimeUnix = moment(data.close_date_time).unix();
      }

      // Calculate time remaining until close time
      if (closeTimeUnix && !isNaN(closeTimeUnix)) {
        let timeLeftFromCloseTime = closeTimeUnix - now;

        // If timeLeft hasn't been set yet, or if this time is shorter, use it
        if (timeLeft === null || timeLeftFromCloseTime < timeLeft) {
          timeLeft = Math.max(0, timeLeftFromCloseTime);
        }
      }
    }

    // Calculate time left based on time limit (if active)
    if (data.timeLimitActive === 1 && data.startTime && data.startTime > 0) {
      const timeLimitInSeconds = ((data?.timeHour || 0) * 60 * 60) + ((data?.timeMin || 0) * 60);
      const elapsedTime = now - data.startTime;
      const timeLeftFromTimeLimit = timeLimitInSeconds - elapsedTime;

      if (timeLeft === null || timeLeftFromTimeLimit < timeLeft) {
        timeLeft = Math.max(0, timeLeftFromTimeLimit);
      }
    } 
    else{
      const timeLimitInSeconds = ((data?.timeHour || 0) * 60 * 60) + ((data?.timeMin || 0) * 60);
      const timeLeftFromTimeLimit = timeLimitInSeconds < timeLeft ? timeLimitInSeconds : timeLeft;
      timeLeft = Math.max(0, timeLeftFromTimeLimit);
    }

    // If we still don't have a valid timeLeft, it means the required data isn't available
    if (timeLeft === null) {
      return string ? "--:--:--" : { hours: null, minutes: null, seconds: null };
    }
    // Check if timeLeft is greater than the maximum time defined by timeHour and timeMin
    const maxTimeInSeconds = ((data?.timeHour || 0) * 60 * 60) + ((data?.timeMin || 0) * 60);
    if (maxTimeInSeconds > 0 && timeLeft > maxTimeInSeconds) {
      return string ? "--:--:--" : { hours: null, minutes: null, seconds: null };
    }

    // Convert seconds to hours, minutes, seconds
    const hours = Math.floor(timeLeft / 3600);
    const minutes = Math.floor((timeLeft % 3600) / 60);
    const seconds = Math.floor(timeLeft % 60);

    if (string) {
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    } else {
      return { hours, minutes, seconds };
    }
  }

  useEffect(() => {
    if(isAssessmentReview){
      GetQuizQuestionsService({quid: props.quizId, assignment_id: props.assessmentId, isReview : 1, intake_id: sid})
      .then((res) => {
        try {
          if(Object.values(res?.data?.signatures || {})?.length != 0){
            localStorage.setItem('Signatureqa',JSON.stringify(res?.data?.signatures))
          }else{
            localStorage.removeItem('Signatureqa')
          }
        } catch (error) {
          console.log(error)
        }
        dispatch(clearQuiz())

        const obj = {};
        const allQuizId = [];
        res.data.questions.filter(list => (list && list.questions && list.questions.length > 0)).map(q => {
          if (q.type === 0) {
            obj[`qa${q.questions[0].qid}qa`] = q.questions[0]
            allQuizId.push(q.questions[0].qid);
          } else {
            obj[`qa${q.questions[0].qid}qa`] = q.questions
            allQuizId.push(q.questions.map(q => q.qid));
          }
        })

        res.data.questions.filter(list=>(list && list.questions && list.questions.length > 0)).map(q => {
          q.questions.map(ques=>{
              localStorage.setItem(`@qa${ques.qid}qa`, 0);
          })
        })

        dispatch(setQuizComplete(obj));

              props.setshow({ question: true });
      })
      .catch((err) => {
        console.log(err);
      });
    }
  },[isAssessmentReview])
  
  return (
    <>
      <div className="tab-pane fade show active" id="Assessment-Detail">
        <div className="test-series-main-block">
          <div className="test-series-main-left-blk">
            <div className="test-series-main-heading icon-add mb-15">
              <h4>{props.data && props.data.name ? props.data.name : ""}{props.data && props.data.code ? ` (${props.data.code})` : ""}</h4>
              <span className="test-series-main-left-heading-act">
                <SystemIcons data={props.data} />
              </span>
            </div>
            
            <div className="breadcrumb-btn-blk">
              <div className="custom-breadcrumb">
                <ul>
                  <li className="custom-breadcrumb-item inactive">
                    <a href="#" onClick={(e)=>{e.preventDefault()}}>
                      <i className="fal fa-home"></i>
                    </a>
                  </li>
                  {props.showSystemCheck &&
                    <li className="custom-breadcrumb-item inactive">
                      <a href="#" onClick={(e)=>{e.preventDefault()}}>System Check</a>
                    </li>
                  }
                  {props.showIdentification &&
                    <li className="custom-breadcrumb-item inactive">
                      <a href="#" onClick={(e)=>{e.preventDefault()}}>Student Identification</a>
                    </li>
                  }
                  <li className="custom-breadcrumb-item inactive">
                    <a href="#" onClick={(e)=>{e.preventDefault()}}>Test</a>
                  </li>
                </ul>
              </div>
              <div className="breadcrumb-btns">
                <button onClick={()=>{disableFileUpload ? props.backBtn(true) : props.backBtn()}} type="button" className="btn btn-primary">
                  <i className="fal fa-chevron-left"></i> Back{" "}
                </button>
                <div className="breadcrumb-right-btns">
                  {(props.data.quiz_id == 0 && props.data.launched == 0 && !isTimeUp) ? 
                    props.data.assFile != '' ? 
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={props?.loader==true}
                        onClick={()=>{props.launchDownload({isLaunchedAndDownload: true, isOnlyDownload: false});TimeLeft(props.data)}}
                      >
                        {props?.loader==true ?  <i className={`fas fa-cog fa-spin`}></i>  : <i className="fal fa-download"></i>}&nbsp; Launch & Download
                      </button>
                    :   
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={props?.loader==true}
                        onClick={()=>{props.launchDownload({isLaunchedAndDownload: false, isOnlyDownload: false});TimeLeft(props.data)}}
                      >
                        {props?.loader==true ?  <i className={`fas fa-cog fa-spin`}></i>  : <i className="fal fa-rocket"></i>}&nbsp; Launch
                      </button>
                  : null }
                  {props.data.quiz_id == 0 && props.data.launched == 1 && props.data.assFile != '' ?
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={props?.loader==true}
                      onClick={()=>{props.launchDownload({isLaunchedAndDownload: false, isOnlyDownload: true})}}
                    >
                      {props?.loader==true ?  <i className={`fas fa-cog fa-spin`}></i>  : <i className="fal fa-download"></i>}&nbsp; Download
                    </button>
                  : null}
                </div>
              </div>
            </div>

            <div className="test-series-main-heading mb-15">
              <h4>Details</h4>
            </div>
            <div className="assessment__details__wrapper">
              <div className="custom__accordion__box">
                <div className="accordion__head d-flex align-items-center justify-content-between">
                  <div className="head__bar">
                    {isAssessmentReview ? <>
                      <i className="fal fa-ballot-check"></i>
                      Assessment Information
                      </> :
                      <>
                        {props?.data?.timeLimitActive === 1 && props.data.isSubmitLeft != 0 ?
                          <i className="fal fa-clock"></i>
                          : <i className="fal fa-ballot-check"></i>
                        }
                        {props?.data?.timeLimitActive === 1 && props.data.isSubmitLeft != 0
                          ? <div className="timer">Time Limit: <span className="as-text-red">
                            {!props.data.launched || props.data.launched !== 1
                              // ? `${String(props?.data?.timeHour || 0).padStart(2, '0')}:${String(props?.data?.timeMin || 0).padStart(2, '0')}:00`
                              ? calculateTimeLeftOpt(props.data)
                              : seconds === null
                                ? `--:--:--`
                                : (hours === '0' && minutes === ' 0' && seconds === '0')
                                  ? `00:00:00`
                                  : timeLeft
                            }
                          </span>
                          </div>
                          : "Assessment Information"
                        }
                      </>
                    }
                  </div>
                  <button type="button" onClick={() => setOpen(!open)} className="btn btn-primary">
                    <i className={open ? "fal fa-chevron-up" : "fal fa-chevron-down"}></i>
                  </button>
                </div>
            <div className={"textseries-content-blk white-brd-blk mb-4 "  + (open ? "show" : "")}>
              <div className={`row ${props.quizId ? '' : 'mb-30'}`}>
                <div className="col-md-6">
                  <div className="textseries-info-details">
                    <ul>
                      <li>
                        <span className="heading">Type:</span>
                        <span className="content">
                          {props?.data?.ass_type &&
                            <AssignmentType ass_type={props?.data?.ass_type ? props.data.ass_type : ""} />
                          }
                        </span>
                      </li>
                      <li>
                        <span className="heading">Status:</span>
                        <span className="content">
                          {props?.data?.status &&
                            <AssignmentStatus status={assessmentStatus} />
                          }
                        </span>
                      </li>
                      <li>
                        <span className="heading">Condition:</span>
                        <span className="content">
                          <span className="ts-info-act">
                            <SystemIcons data={props.data} />
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="textseries-info-details">
                    <ul>
                      <li>
                        <span className="heading">Open Date:</span>
                        <span className="content">
                          {props?.data?.open_date_time
                            ? props.data.open_date_time
                            : ""}
                        </span>
                      </li>
                      <li>
                        <span className="heading">Close Date:</span>
                        <span className="content">
                          {props?.data?.close_date_time
                            ? props.data.close_date_time
                            : ""}
                        </span>
                      </li>
                      <li>
                        {props?.data?.timeLimitActive === 1 && <span className="heading">Time Limit:</span>}
                        {props?.data?.timeLimitActive === 1 && <span className="content">{quizTotalTime}</span>}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-12 mt-15">
                  <div className="textseries-info-details">
                    <ul>
                      <li className="">
                        <span className="heading">Submission:</span>
                        {((props.data.Files && (props.data.Files.length > 0)) || props.data.fileName != "") ?
                          <span onClick={() => setShowFile(!showFile)} className="content">
                            List of files <i className={`fal ${showFile ? 'fa-chevron-down' : 'fa-chevron-up'} `}></i>
                          </span>
                          :
                          <span className="content">
                            No attempt
                          </span>
                        }
                      </li>
                          {props.data.ass_type === "Supplementary Exam" && <li className="">
                            <span className="heading">Maximum Mark Achievable: &nbsp;</span>
                            {props.data.maximum_grade_achievable ?
                              <span className="content">
                                {props.data.maximum_grade_achievable}
                              </span>
                              :
                              <span className="content">
                                -
                              </span>
                            }
                          </li>}
                      {showFile && (props.data.Files && (props.data.Files.length > 0) || props.data.fileName != "") ?
                        <div className="uploded-files-block mt-15">
                          <div className="row">
                            {props.data.Files && (props.data.Files.length > 0) ?
                              props.data.Files.map(i => {
                                i.removeF = props.handleRemoveFile
                                i.isInArray = true
                                i.showClose = true
                                return (
                                  RenderAttachList(i)
                                )
                              })
                              :
                              props.data.fileName != "" ?
                                RenderAttachList({ fileName: props.data.fileName, size: props.data.subFileSize, filePath: props.data.filePath, removeF: props.handleRemoveFile, id: props.data.subID, isInArray: false, subFilePath: props.data.subFilePath, showClose: true })
                                :
                                null}
                          </div>
                        </div>
                        : null}
                      {props.quizId &&
                        <li className="">
                          <span className="heading">Attempts:</span>
                          <span className="content">
                            {props.maxAttempt ? props.maxAttempt : 0}
                          </span>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            </div>
            </div>
              {(!props.data.quiz_id && props?.data?.launched === 1) && <div className="textseries-content-blk white-brd-blk mb-4">
                <div className={`profile-doc-upload-blk ${props.data.subFilePath !== null && props.data.subFilePath !== '' && (props.data.subTime == null || props.data.subTime == 0) ? 'final_status_change' : ''}`}>
                  <div className="profile-doc-upload preview_file" style={{}}>
                    <Dropzone
                    key={`dropzone-${props.data.subFilePath !== null && props.data.subFilePath !== '' && (props.data.subTime == null || props.data.subTime == 0) ? 'final_status_change' : ''}`}
                      onChangeStatus={(fileWithMeta, status, allFiles) => {
                      if ((status === 'done' || status === 'ready') && fileWithMeta) {
                      
                        let readyFiles = allFiles.filter(f => ((f.meta.status === 'done' || f.meta.status === 'ready' ) && !f.meta.customId) )
                        clearTimeout(debounceRef.current);
                        debounceRef.current = setTimeout(() => {
                          if (readyFiles.length) {
                            readyFiles = readyFiles.map(f => {
                              if (!f.meta.customId) {
                                f.meta.customId = `${f.meta.name}-${f.meta.size}-${Date.now()}-${Math.random()}`;
                              }
                              return f;
                            });

                            props.onSubmit(readyFiles, setUploadProgress);
                          }
                        }, 300);
                      }
                      }}
                      autoUpload={true}
                      disabled={disableFileUpload}
                      classNames={{ submitButton: 'btn btn-primary submit-file-button', submitButtonContainer: ' btn-upload' }}
                      styles={{ dropzone: { /*minHeight: 225*/ } }}
                      accept=".zip,.jpg,.png,.jpeg,.pdf,.doc,.docx,.txt,.mp4,.mp3,.otf,.xlsx"
                      PreviewComponent={(props) => <CustomFileUploadPreview {...props} uploadProgress={uploadProgress} />}
                      inputContent={
                        <lable key={"1"}>
                          <i className="fas fa-file-upload"></i>
                          <h4>
                            To submit assessment, Drop your file here, or <span>browse</span>
                          </h4>
                          <p>Supports: PDF, DOCX and more</p>
                        </lable>
                      }
                      maxFiles={10}
                    />
                    {!disableFileUpload && props?.data?.Files && props?.data?.Files?.length > 0 && (props.data.subTime == null || props.data.subTime == 0) ? (
                      <div className="btn-action-block examfile-upload-btn">
                        <button
                          onClick={()=>props.setToFinal(false)}
                          type="button"
                          className="btn btn-danger"
                        >
                          {props?.loadFinal==true ? <i className={`fas fa-cog fa-spin`}></i> : <i className="fal fa-check"></i>}&nbsp; Change to Final Status
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
            </div>}
            {(props.data.quiz_id && (props?.data?.launched === 1 || isAssessmentReview == 1)) ?
              <ViewQuestion
                updateSubjectOnly={props.updateSubjectOnly}
                assignmentData={props.data}
                getSubContentMethod={props.getSubContentMethod}
                autoSubmitDetails={autoSubmitDetails}
                quizId={props.quizId}
                setQuizId={props.setQuizId}
                setshow={props.setshow}
                setrId={props.setrId}
                rId={props.rId}
                aid={props.assessmentId}
                currentTimeStatus={currentTimeStatus}
                initiateReload={props.initiateReload}
                setIsExamLaunchedToFalse={props.setIsExamLaunchedToFalse}
                isSubmiting={props.isSubmiting}
                stop={props.stop}
                isAssessmentReview={isAssessmentReview}
                assPassMark={props?.assPassMark}
                submitQuizAssessment={submitQuizAssessment}
                updateSubmitQuizAssessment={updateSubmitQuizAssessment}
                setIsSigRequired={setIsSigRequired}
                sigPoped={sigPoped}
                setCanBeSTF={setCanBeSTF}
                canBeSTF={canBeSTF}
                isMinutePopupShown={isMinutePopupShown}
                setToShowMinutePopup={setToShowMinutePopup}
              />
              : null
            }
            <div className="textseries-content-blk desc-instruction-blk white-brd-blk mb-15">
              <h4>{Str.detailDes}:</h4>
              {props?.data?.details
                ? ReactHtmlParser(props.data.details)
                : Str.noInstruction}
            </div>
          </div>
          <div className="test-series-main-right-blk">
            <div className="step-sidebar-space">
              <SysCheckSideIcon props={props} />
            </div>

            <div className="test-series-steps">
              <ul>
                <li className="test-series-steps-item active done">
                  <a href="#" onClick={(e)=>{e.preventDefault()}}>
                    <span>1</span> <b>Assessment Detail</b>
                  </a>
                </li>
                {props.showSystemCheck ?
                  <li className="test-series-steps-item active done">
                    <a href="#" onClick={(e)=>{e.preventDefault()}}>
                      <span>2</span> <b>System Check</b>
                    </a>
                  </li>
                  : null}
                {props.showIdentification ?
                  <li className="test-series-steps-item active done">
                    <a href="#" onClick={(e)=>{e.preventDefault()}}>
                      <span>3</span> <b>Identification</b>
                    </a>
                  </li>
                  : null}
                <li className="test-series-steps-item active done">
                  <a href="#" onClick={(e)=>{e.preventDefault()}}>
                    <span>4</span> <b>Launch Exam</b>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Step5;